import Token from '@/resources/token';

const SUPERADMIN_ROLE = 'superadmin';
const ADMIN_ROLE = 'admin';

export default {
  namespaced: true,
  state: {
    loggingIn: false,
    token: null,
    refreshToken: null,
    role: null,
    userID: null,
    downloadAccess: false
  },
  getters: {
    isAuthenticated(state) {
      return state.token != null && !state.loggingIn;
    },
    isSuperadmin(state) {
      return state.role === SUPERADMIN_ROLE;
    },
    isAdmin(state) {
      return state.role === ADMIN_ROLE;
    },
    isAdminOrSuperadmin(state) {
      return state.role === ADMIN_ROLE || state.role === SUPERADMIN_ROLE;
    },
    getToken(state) {
      return state.token;
    },
    isDownloadAccess(state) {
      return state.downloadAccess;
    }
  },

  /* eslint no-param-reassign: ["error", { "props": false }] */
  mutations: {
    startLoggingIn(state) {
      state.loggingIn = true;
    },
    stopLoggingIn(state) {
      state.loggingIn = false;
    },
    setToken(state, data) {
      const resourceOwner = data.resource_owner;
      if (resourceOwner) {
        state.role = resourceOwner.role;
        localStorage.setItem('role', resourceOwner.role);
        state.userID = resourceOwner.id;
        localStorage.setItem('userID', resourceOwner.id);
        state.downloadAccess = resourceOwner.download_access;
        localStorage.setItem('downloadAccess', resourceOwner.download_access);
      }
      state.token = data.access_token;
      localStorage.setItem('token', data.access_token);
      state.refreshToken = data.refresh_token;
      localStorage.setItem('refreshToken', data.refresh_token);
    },
    clearToken(state) {
      state.token = null;
      localStorage.removeItem('token');
      state.refreshToken = null;
      localStorage.removeItem('refreshToken');
      state.role = null;
      localStorage.removeItem('role');
      state.userID = null;
      localStorage.removeItem('userID');
      state.downloadAccess = false;
      localStorage.removeItem('downloadAccess');
    },
    restoreToken(state) {
      state.token = localStorage.token;
      state.refreshToken = localStorage.refreshToken;
      state.role = localStorage.role;
      state.userID = localStorage.userID;
      state.downloadAccess = localStorage.downloadAccess === 'true';
    }
  },
  actions: {
    signIn({ commit }, { username, password }) {
      commit('startLoggingIn');
      return new Promise((resolve, reject) => {
        Token.create({ username, password })
          .then(response => {
            commit('setToken', response.data);
            commit('stopLoggingIn');
            resolve();
          })
          .catch(e => {
            commit('stopLoggingIn');
            reject(e);
          });
      });
    },
    signOut({ state, commit }) {
      return new Promise((resolve, reject) => {
        Token.revoke({ token: state.token })
          .then(() => {
            commit('clearToken');
            resolve();
          })
          .catch(e => reject(e));
      });
    },
    refreshToken({ state, commit }) {
      return new Promise((resolve, reject) => {
        const { refreshToken } = state;
        commit('clearToken');
        if (refreshToken) {
          commit('startLoggingIn');
          Token.refresh(refreshToken)
            .then(response => {
              commit('setToken', response.data);
              commit('stopLoggingIn');
              resolve();
            })
            .catch(e => {
              commit('stopLoggingIn');
              reject(e);
            });
        } else {
          reject();
        }
      });
    }
  }
};
